module.exports = __webpack_public_path__ + "static/media/masterquantity.cc008df5.svg";